import { useSearchParams } from 'react-router'

// This can be replaced with useSearchParams once we upgrade to react-router-dom v6
export const useFaxPageQueryParams = () => {
  const [searchParams, setSearchParams] = useSearchParams()
  const page = Number(searchParams.get('page')) || 1

  const setPage = (pageNumber: number) => {
    const newParams = new URLSearchParams(searchParams)
    newParams.set('page', pageNumber.toString())
    setSearchParams(newParams)
  }

  return { page, setPage }
}
